/**
 * Purchase Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Purchase Order Schema
 */
export interface PurchaseOrder { 
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    id?: number;
    purchaseRequest?: number;
    series?: string;
    vendorCode?: string;
    postingDate?: string;
    deliveryDate?: string;
    description?: string;
    status?: PurchaseOrder.StatusEnum;
    deleteFlag?: boolean;
}
export namespace PurchaseOrder {
    export const StatusEnum = {
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Rejected: 'REJECTED',
        Sent: 'SENT',
        VendorConfirmed: 'VENDOR_CONFIRMED',
        Delivered: 'DELIVERED',
        Done: 'DONE',
        Closed: 'CLOSED',
        Cancelled: 'CANCELLED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


